import { Theme } from '@material-ui/core';
import { AppBarClassKey } from '@material-ui/core/AppBar';

const MuiAppBar = (theme: Theme): Partial<Record<AppBarClassKey, unknown>> => ({
    root: {
        borderLeftWidth: 0,
        borderRightWidth: 0,
    },
    colorSecondary: {
        backgroundColor: theme.palette.secondary.dark,
    },
});

export default MuiAppBar;
